import { EnvironmentService } from '@core/services/environment.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import type { DocumentType, PaymentDetails, ResponseConfirmOperation } from '@core/services/daviplata.interface';
import { encodeApiPathSegment } from '@core/utils/api-path.utils';

@Injectable({
  providedIn: 'root'
})
export class NequiService {
  private get baseUrl(): string {
    return this.environmentService.env.apiConfig.payinCheckoutBackendUrl;
  }

  private operationPath(idTransaction: string): string {
    return encodeApiPathSegment(idTransaction);
  }

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
  ) { }

  findDocumentByCountry(): Observable<DocumentType[]> {
    return this.http.get<DocumentType[]>(`${this.baseUrl}common/master-parameters/api/find/documentCountry/COL?documentType=N`);
  }

  initOperation(idTransaction: string, body: any, verification: string): Observable<ResponseConfirmOperation> {
    const headers = new HttpHeaders({
      verification,
    });
    return this.http.post<ResponseConfirmOperation>(
      `${this.baseUrl}processor/nequi/operation/init/${this.operationPath(idTransaction)}`,
      body,
      { headers },
    );
  }

  confirmOperation(idTransaction: string, body: any, verification: string): Observable<ResponseConfirmOperation> {
    const headers = new HttpHeaders({
      verification,
    });
    return this.http.post<ResponseConfirmOperation>(
      `${this.baseUrl}processor/nequi/operation/confirm/${this.operationPath(idTransaction)}`,
      body,
      { headers },
    );
  }

  expirateOperation(idTransaction: string, verification: string): Observable<ResponseConfirmOperation> {
    const headers = new HttpHeaders({
      verification,
    });
    return this.http.post<ResponseConfirmOperation>(
      `${this.baseUrl}processor/nequi/operation/expire/${this.operationPath(idTransaction)}`,
      null,
      { headers },
    );
  }

  getPaymentDetails(idTransaction: string, verification: string): Observable<PaymentDetails> {
    const headers = new HttpHeaders({
      verification,
    });

    return this.http.post<PaymentDetails>(
      `${this.baseUrl}common/operation/find/${this.operationPath(idTransaction)}`,
      {},
      { headers },
    );
  }
}
